var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: { slot: "detail", model: _vm.model },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                { attrs: { disabled: _vm.formDisabled } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["eletronicSigned.processNo"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: "",
                              disabled: _vm.isDisabled
                            },
                            model: {
                              value: _vm.model.processNo,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "processNo", $$v)
                              },
                              expression: "model.processNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["eletronicSigned.startTime"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol
                          }
                        },
                        [
                          _c("a-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              disabled: _vm.isDisabled,
                              format: _vm.dateFormat,
                              getCalendarContainer: function(node) {
                                return node.parentNode
                              }
                            },
                            model: {
                              value: _vm.model.createTime,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "createTime", $$v)
                              },
                              expression: "model.createTime"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "a-tabs",
                {
                  attrs: {
                    "default-active-key": "1",
                    size: "large",
                    "tab-bar-style": {
                      marginBottom: "24px",
                      paddingLeft: "16px"
                    }
                  },
                  on: { change: _vm.changeTabs }
                },
                [
                  _c(
                    "a-tab-pane",
                    {
                      key: "1",
                      style:
                        _vm.innerFullscreen === false
                          ? _vm.setEdit === true
                            ? "max-height: 32vh;overflow:scroll"
                            : "max-height: 45vh;overflow:scroll"
                          : _vm.setEdit === true
                          ? "max-height: 45vh;overflow:scroll"
                          : "max-height: 65vh;overflow:scroll",
                      attrs: { loading: "true", tab: _vm.tabName }
                    },
                    [
                      _vm.processModel.applicationCode === "env_audit"
                        ? _c(
                            "div",
                            [
                              _c("a-form-model-item", {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm.processModel.applicationCode === "ipsys" &&
                  (_vm.model.taskCode === "ApproveTask8" ||
                    _vm.model.taskCode === "ApproveTask9") &&
                  1 === 0
                    ? _c(
                        "a-tab-pane",
                        {
                          key: "2",
                          style:
                            _vm.innerFullscreen === false
                              ? _vm.setEdit === true
                                ? "max-height: 32vh;overflow:scroll"
                                : "max-height: 45vh;overflow:scroll"
                              : _vm.setEdit === true
                              ? "max-height: 45vh;overflow:scroll"
                              : "max-height: 65vh;overflow:scroll",
                          attrs: {
                            tab: _vm.language["eletronicSigned.fileUrls"]
                          }
                        },
                        [
                          _c(
                            "a-col",
                            { attrs: { span: 24 } },
                            [
                              _c("p", { staticStyle: { color: "red" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.language[
                                      "eletronicSigned.fileUrlsPrompt"
                                    ]
                                  )
                                )
                              ]),
                              _c(
                                "a-form-model-item",
                                {
                                  attrs: {
                                    label:
                                      _vm.language["eletronicSigned.fileUrls"],
                                    required: "",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol
                                  }
                                },
                                [
                                  _c("j-upload", {
                                    attrs: {
                                      "upload-source": "ipsys",
                                      customName: true,
                                      bizPath: "null",
                                      multiple: _vm.fileAttribute.fileMultiple,
                                      disabled:
                                        _vm.model.taskCode !== "ApproveTask8"
                                    },
                                    on: { change: _vm.handleChange },
                                    model: {
                                      value: _vm.fileUrls,
                                      callback: function($$v) {
                                        _vm.fileUrls = $$v
                                      },
                                      expression: "fileUrls"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "a-tab-pane",
                    {
                      key: "3",
                      style:
                        _vm.innerFullscreen === false
                          ? _vm.setEdit === true
                            ? "max-height: 32vh;overflow:scroll"
                            : "max-height: 45vh;overflow:scroll"
                          : _vm.setEdit === true
                          ? "max-height: 45vh;overflow:scroll"
                          : "max-height: 65vh;overflow:scroll",
                      attrs: { tab: _vm.singTableName }
                    },
                    [
                      _c(
                        "a-card",
                        {
                          attrs: {
                            loading: _vm.loading,
                            bordered: false,
                            title: _vm.language["eletronicSigned.signList"]
                          }
                        },
                        [
                          _c("a-table", {
                            attrs: {
                              size: "middle",
                              rowKey: "id",
                              columns: _vm.columns,
                              pagination: false,
                              dataSource: _vm.dataSource,
                              loading: _vm.loading
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "approveResult",
                                fn: function(text, record) {
                                  return _c("span", {}, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          text === "Cancel"
                                            ? _vm.language[
                                                "eletronicSigned.termination"
                                              ]
                                            : record.actionTextLocalLang
                                        ) +
                                        "\n                "
                                    )
                                  ])
                                }
                              }
                            ])
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-card",
                        {
                          attrs: {
                            loading: _vm.loading,
                            bordered: false,
                            title: _vm.language["eletronicSigned.signPerson"]
                          }
                        },
                        [
                          _c("a-table", {
                            attrs: {
                              columns: _vm.approverColumns,
                              size: "middle",
                              "data-source": _vm.approverData,
                              pagination: false,
                              loading: _vm.loading
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-tab-pane",
                    {
                      key: "4",
                      style:
                        _vm.innerFullscreen === false
                          ? _vm.setEdit === true
                            ? "max-height: 32vh;overflow:scroll"
                            : "max-height: 45vh;overflow:scroll"
                          : _vm.setEdit === true
                          ? "max-height: 45vh;overflow:scroll"
                          : "max-height: 65vh;overflow:scroll",
                      attrs: {
                        tab: _vm.language["eletronicSigned.processChart"]
                      }
                    },
                    [
                      _c("img", {
                        staticStyle: { width: "100%" },
                        attrs: { src: _vm.getProcessChart() }
                      })
                    ]
                  )
                ],
                1
              ),
              _vm.setEdit
                ? _c(
                    "a-card",
                    {
                      attrs: {
                        bordered: false,
                        title:
                          _vm.processModel.applicationCode === "ipsys" &&
                          _vm.model.taskCode === "ApproveTask8"
                            ? ""
                            : _vm.language["eletronicSigned.signOpinion"]
                      }
                    },
                    [
                      _vm.processModel.applicationCode === "ipsys"
                        ? _c(
                            "div",
                            [
                              !(_vm.model.taskCode === "ApproveTask8")
                                ? _c(
                                    "a-row",
                                    [
                                      _c("a-textarea", {
                                        model: {
                                          value: _vm.model.comments,
                                          callback: function($$v) {
                                            _vm.$set(_vm.model, "comments", $$v)
                                          },
                                          expression: "model.comments"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  !(_vm.model.taskCode === "ApproveTask8")
                                    ? _c(
                                        "a-button",
                                        {
                                          staticStyle: {
                                            color: "blue",
                                            right: "20px",
                                            "padding-left": "30px",
                                            "padding-right": "30px"
                                          },
                                          on: { click: _vm.agree }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.language[
                                                "eletronicSigned.agree"
                                              ]
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  !(_vm.model.taskCode === "ApproveTask8")
                                    ? _c(
                                        "a-button",
                                        {
                                          staticStyle: {
                                            color: "red",
                                            left: "20px",
                                            "padding-left": "30px",
                                            "padding-right": "30px"
                                          },
                                          on: { click: _vm.reject }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.language[
                                                "eletronicSigned.reject"
                                              ]
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm.processModel.modelCode === "cst_check" &&
                          _vm.model.taskCode === "Applicant"
                        ? _c(
                            "div",
                            [
                              _c(
                                "a-row",
                                [
                                  _c("a-textarea", {
                                    model: {
                                      value: _vm.model.comments,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "comments", $$v)
                                      },
                                      expression: "model.comments"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: {
                                        color: "blue",
                                        right: "20px",
                                        "padding-left": "30px",
                                        "padding-right": "30px"
                                      },
                                      on: { click: _vm.agree }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.language["eletronicSigned.agree"]
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm.processModel.modelCode ===
                            "cst_interrupt_confirm" &&
                          _vm.model.taskCode === "Operator"
                        ? _c(
                            "div",
                            [
                              _c(
                                "a-row",
                                [
                                  _c("a-textarea", {
                                    model: {
                                      value: _vm.model.comments,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "comments", $$v)
                                      },
                                      expression: "model.comments"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: {
                                        color: "blue",
                                        right: "20px",
                                        "padding-left": "30px",
                                        "padding-right": "30px"
                                      },
                                      on: { click: _vm.agree }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.language["eletronicSigned.agree"]
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm.processModel.modelCode ===
                            "cst_interrupt_recovery" &&
                          _vm.model.taskCode === "FireResponsible"
                        ? _c(
                            "div",
                            [
                              _c(
                                "a-row",
                                [
                                  _c("a-textarea", {
                                    model: {
                                      value: _vm.model.comments,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "comments", $$v)
                                      },
                                      expression: "model.comments"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: {
                                        color: "blue",
                                        right: "20px",
                                        "padding-left": "30px",
                                        "padding-right": "30px"
                                      },
                                      on: { click: _vm.agree }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.language["eletronicSigned.agree"]
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _c(
                            "div",
                            [
                              _c(
                                "a-row",
                                [
                                  _c("a-textarea", {
                                    model: {
                                      value: _vm.model.comments,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "comments", $$v)
                                      },
                                      expression: "model.comments"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: {
                                        color: "blue",
                                        right: "20px",
                                        "padding-left": "30px",
                                        "padding-right": "30px"
                                      },
                                      on: { click: _vm.agree }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.language["eletronicSigned.agree"]
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: {
                                        color: "red",
                                        left: "20px",
                                        "padding-left": "30px",
                                        "padding-right": "30px"
                                      },
                                      on: { click: _vm.reject }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.language["eletronicSigned.reject"]
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }